<div [formGroup]="form" #container>
  <div [formGroupName]="question.key" class="open-tile-checkbox" [class]="'tile-length-' + question.settings.choices.length" [ngClass]="{ 'tile-align-left': question.settings.align === 'left', 'tile-align-right': question.settings.align === 'right' }">
    <ng-container *ngFor="let option of question.settings.choices; index as i;">

      <div class="column-stop" *ngIf="i > 0 && i % 1 === 0 && columns === 1"></div>
      <div class="column-stop" *ngIf="i > 0 && i % 2 === 0 && columns === 2"></div>
      <div class="column-stop" *ngIf="i > 0 && i % 3 === 0 && columns === 3"></div>

      <div class="checkbox-wrapper">
        <mat-checkbox [formControlName]="option.value" [value]="option.value" (change)="playAnimation(option)" [ngClass]="{ 'active': fieldValue[option.value] }" [class]="question.settings.size">
          <open-svg-icon *ngIf="question.settings.icon_type !== 'animation' && option.icon" name="{{ option.icon }}" [class]="question.settings.size === 'small' ? 'small' : 'xmedium'"></open-svg-icon>
          <div class="lottie-player-container" *ngIf="question.settings.icon_type === 'animation' && option.icon">
            <lottie-player [src]="option.icon" background="transparent" class="medium primary {{ option.value }}"></lottie-player>
          </div>
          <div class="tile-label-content">
            <b class="label">{{ option.label }}</b>
            <p class="input-small" *ngIf="option.text">{{ option.text }}</p>
          </div>
        </mat-checkbox>
        <div *ngIf="option.help && (!option.help.type || option.help.type === 'tooltip')" class="tooltip">
          <open-tooltip [tooltipContent]="option.help.content"></open-tooltip>
        </div>
      </div>

    </ng-container>
  </div>
</div>
